/**
 * AnniversaryAutoPush
 * -------------------
 * Daily 9-11 AM window: if user is logged in and has customers with today's birthday/anniversary/event,
 * fire browser Notification (once per day) + toast with jump-to-tab link.
 *
 * Uses localStorage `avm_reminder_last_shown` = YYYY-MM-DD to dedupe.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const LAST_KEY = 'avm_reminder_last_shown';

export default function AnniversaryAutoPush() {
  const navigate = useNavigate();

  useEffect(() => {
    let stopped = false;

    const check = async () => {
      if (stopped) return;
      const now = new Date();
      const today = now.toISOString().slice(0, 10);
      const hour = now.getHours();
      // Only during 9 AM - 11 AM local
      if (hour < 9 || hour > 11) return;
      const last = localStorage.getItem(LAST_KEY);
      if (last === today) return;

      try {
        const r = await api.get('/avm/reminders/today');
        const total = r.data?.total || 0;
        if (total <= 0) return;
        localStorage.setItem(LAST_KEY, today);
        // Browser notification
        if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          try {
            const n = new Notification('🎂 Aaj ki wishes yaad hain?', {
              body: `${total} customer${total > 1 ? 's ke' : ' ka'} birthday/anniversary/event aaj hai. Ek click me wish bhejo.`,
              icon: '/favicon.ico', tag: 'avm-daily-reminder',
            });
            n.onclick = () => { window.focus(); navigate('/vyapaar-master'); };
          } catch { /* noop */ }
        }
        // In-app toast (always shown)
        toast(
          (t) => (
            <span onClick={() => { toast.dismiss(t.id); navigate('/vyapaar-master'); }}
                  className="cursor-pointer">
              🎂 <b>{total}</b> customer{total > 1 ? 's' : ''} to wish today · <u className="text-emerald-300">Tap to open</u>
            </span>
          ),
          { duration: 12000, icon: '🎉' }
        );
      } catch { /* silent */ }
    };

    // Immediate check + every 30 min
    check();
    const iv = setInterval(check, 30 * 60 * 1000);
    return () => { stopped = true; clearInterval(iv); };
  }, [navigate]);

  return null;
}
